export function getQueryParams () {
  const param = {}
  const query = window.location.search.substr(1)
  query.split('&').forEach(q => {
    let [key, value] = q.split('=').map(p => {
      return decodeURIComponent(p)
    })
    param[key] = value
  })
  return param
}

export function getURL (url) {
  return new Promise((resolve, reject) => {
    const req = new XMLHttpRequest()
    req.open('GET', url, true)
    req.onload = () => {
      if (req.status === 200) resolve(req.responseText)
      else reject(new Error(req.statusText))
    }
    req.onerror = () => {
      reject(new Error(req.statusText))
    }
    req.send(null)
  })
}

export function csv2ary (str) {
  return str.trim().split('\n').map((line) => line.split(','))
}

export const getInitData = (ary) => {
  const clacSig = ary[0].slice(16)
  console.log({clacSig})
  return ary.slice(1).reduce((info, cols) => {
    const id = cols[0]
    const name = cols[1]
    const title = cols[3]
    const clacIdCols = cols.slice(16)
    getIndex(info.index, id, title, name)
    info.calcIds[id.substr(1)] = clacSig.filter((_, idx) => clacIdCols[idx] == '●')
    return info
  }, { index: [], calcIds: {} })
}

const getIndex = (list, id, title, name) => {
  Array.from(title.matchAll(/\d+/g))
    .map(m => parseInt(m[0]))
    .reduce((pairs, cur, idx, ori) => {
      if (idx % 2 == 0) {
        pairs.push([cur, ori[idx + 1]])
      }
      return pairs
    }, [])
    .reduce((myList, [start, end]) => {
      for (
        let n = start, stop = end ? end : start;
        n <= stop;
        n++
      ) {
        if (n === 2193) {
          for (const sfx of ['M', 'L']) {
            myList.push({
              key: `C${n}`,
              sig: `C${n}${sfx}`,
              title: 'C2193M/L',
              name
            })
          }
        } else {
          myList.push({
            key: id,
            sig: id.replace(/\d+/, n),
            title,
            name
          })
        }
      }
    }, list)
}

export function storageAvailable(type) {
  let storage
  try {
    storage = window[type]
    let x = "__storage_test__"
    storage.setItem(x, x)
    storage.removeItem(x)
    return true
  } catch (e) {
    return (
      e instanceof DOMException &&
      // everything except Firefox
      (e.code === 22 ||
        // Firefox
        e.code === 1014 ||
        // test name field too, because code might not be present
        // everything except Firefox
        e.name === "QuotaExceededError" ||
        // Firefox
        e.name === "NS_ERROR_DOM_QUOTA_REACHED") &&
      // acknowledge QuotaExceededError only if there's something already stored
      (storage && storage.length !== 0)
    )
  }
}



// WEBPACK FOOTER //
// ./src/api/utils.js